import { useNavigate } from 'react-router-dom';
import { useMutation } from 'urql';
import Swal from 'sweetalert2';
import PageHeader from '@/components/common/PageHeader.jsx';
import ProveedorForm from './ProveedorForm.jsx';
import { M_CREATE_PROVEEDOR } from '@/graphql/suppliers.gql.js';
import { withIdempotencyKey } from '@/utils/idempotency.js';

export default function NuevoProveedor() {
  const navigate = useNavigate();
  const [createResult, createSupplier] = useMutation(M_CREATE_PROVEEDOR);

  const handleSubmit = async input => {
    const result = await createSupplier({ input }, withIdempotencyKey('proveedor-create'));
    if (result.error) {
      console.error('Error creando proveedor:', result.error); // eslint-disable-line no-console
      await Swal.fire('No pudimos crear el proveedor', result.error.message, 'error');
      return;
    }
    if (!result.error) {
      await Swal.fire({
        title: 'Proveedor creado',
        text: 'El proveedor quedó registrado correctamente.',
        icon: 'success',
        timer: 1600,
        showConfirmButton: false,
      });
      navigate('/admin/proveedores', { replace: true });
    }
  };

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title="Nuevo proveedor"
        description="Registrá los datos fiscales y de contacto para habilitarlo en el flujo de compras."
        breadcrumbs={[
          { label: 'Administración', href: '/admin' },
          { label: 'Proveedores', href: '/admin/proveedores' },
          { label: 'Nuevo proveedor' },
        ]}
      >
        <span className="rounded-full bg-[rgba(var(--panel),0.55)] px-3 py-1 text-xs font-semibold text-[rgb(var(--brand))]">
          Alta rápida
        </span>
      </PageHeader>

      <ProveedorForm
        onSubmit={handleSubmit}
        onCancel={() => navigate(-1)}
        submitLabel="Crear proveedor"
        cancelLabel="Cancelar"
        loading={createResult.fetching}
      />
    </div>
  );
}
